var formatNumber = function (value) {
    if (!isNumber(value)) {
        return;
    }
    var stringValue = String(value);
    var intValue = parseInt(stringValue);
    // если в строке больше 6 символов - округляем до миллионов
    if (stringValue.length > 6) {
        return calcFormatted(intValue, 1000000) + 'M';
    }
    // если в строке больше 3 символов - округляем до тысяч
    if (stringValue.length > 3) {
        return calcFormatted(intValue, 1000) + 'K';
    }
    return intValue.toString();
};
var calcFormatted = function (intValue, multiplier) {
    var abs = Math.abs(intValue) || 0;
    var formattedValue = "".concat(Math.sign(intValue) * parseFloat((abs / multiplier).toFixed(1)));
    return formattedValue.replace('.', ',');
};
var isNumber = function (value) { return typeof value === 'number'; };

export { formatNumber, isNumber };
